import { Box } from "@mui/material";

import { Text } from "../../components/Text";

export interface ChatEmptyStateProps {
  /**
   * Worker name to personalize the empty state message
   */
  workerName: string;
}

/**
 * Empty state component for the chat panel.
 * Displays a friendly message when there are no messages in the chat yet.
 */
export function ChatEmptyState(props: ChatEmptyStateProps) {
  const { workerName } = props;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        padding: 4,
      }}
    >
      <Text
        variant="body2"
        textAlign="center"
        sx={(theme) => ({ color: theme.palette.text.secondary })}
      >
        No messages yet. Start a conversation with {workerName}!
      </Text>
    </Box>
  );
}
